export default __webpack_public_path__ + "static/media/ret_sta_5.4ed5d1fc.jpeg";